var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "sidebar-mobile" }, [
        _c(
          "div",
          { staticClass: "sidebar-mobile__container" },
          [
            _vm.canContactTeam
              ? [
                  _vm.rm
                    ? _c("ContactTeamMobileItem", {
                        attrs: { item: _vm.rm, "modal-key": "contactRM" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.am
                    ? _c("ContactTeamMobileItem", {
                        attrs: { item: _vm.am, "modal-key": "contactAM" }
                      })
                    : _vm._e()
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._m(0)
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.showMenu,
            expression: "showMenu"
          }
        ],
        attrs: { type: "checkbox", id: "toggle-menu" },
        domProps: {
          checked: Array.isArray(_vm.showMenu)
            ? _vm._i(_vm.showMenu, null) > -1
            : _vm.showMenu
        },
        on: {
          change: function($event) {
            var $$a = _vm.showMenu,
              $$el = $event.target,
              $$c = $$el.checked ? true : false
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v)
              if ($$el.checked) {
                $$i < 0 && (_vm.showMenu = $$a.concat([$$v]))
              } else {
                $$i > -1 &&
                  (_vm.showMenu = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.showMenu = $$c
            }
          }
        }
      }),
      _vm._v(" "),
      _c("NavMenuMobile")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sidebar-mobile__menu-btn" }, [
      _c("label", { attrs: { for: "toggle-menu" } }, [_vm._v("MENU")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }